module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/2@2x_66035fff8c92b852d72c90b05d9f6202.png";